<template>
  <TheMenuLayout>
    <BaseSectionHeader v-if="isOnRouteListQcm">
      Liste des QCMs disponibles
    </BaseSectionHeader>
    <BaseSectionHeader v-else-if="isOnRouteListWhiteTests">
      Liste des concours blancs disponibles
    </BaseSectionHeader>
    <BaseSectionHeader v-else>
      Liste des annales disponibles
    </BaseSectionHeader>

    <v-col cols="12" xs="6">
      <v-select label="Matière" v-model="subjectId" @change="changeSubject" :items="testsSubjects" item-text="name"
        item-value="id" clearable />
    </v-col>

    <v-progress-circular v-if="testsLoading" indeterminate />
    <BaseList v-else :items="items" />
    <BaseEmptyState v-if="!items.length && !testsLoading">
      Aucun QCM disponible
    </BaseEmptyState>
    <v-pagination v-if="pageLength" v-model="page" @input="loadMoreTests" :length="pageLength" />
  </TheMenuLayout>
</template>

<script>
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import BaseSectionHeader from '@/components/BaseSectionHeader.vue';
import BaseList from '@/components/BaseList.vue';
import BaseEmptyState from '@/components/BaseEmptyState.vue';
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { isNil, filter } from 'lodash';

export default {
  name: 'TestList',
  components: {
    TheMenuLayout,
    BaseSectionHeader,
    BaseList,
    BaseEmptyState,
  },
  created() {
    this.testsLoading = true;
    this.fetchTestsSubjects();
    if (this.isOnRouteListWhiteTests) {
      this.fetchConcoursBlancs({ page: 1, subjectId: this.subjectId }).then(() => {
        this.testsLoading = false;
      });
    } else {
      this.fetchTests({ page: 1, subjectId: this.subjectId }).then(() => {
        this.testsLoading = false;
      });
    }
  },
  data() {
    return {
      page: 1,
      testsLoading: false,
    };
  },
  watch: {
    $route() {
      this.testsLoading = true;
      if (this.isOnRouteListWhiteTests) {
        this.fetchConcoursBlancs({ page: 1, subjectId: this.subjectId }).then(() => {
          this.testsLoading = false;
        });
      } else {
        this.fetchTests({ page: 1, subjectId: this.subjectId }).then(() => {
          this.testsLoading = false;
        });
      }
    },
  },
  methods: {
    ...mapActions(['fetchTests', 'fetchTestsSubjects', 'fetchConcoursBlancs']),
    changeSubject() {
      this.page = 1;
      this.loadMoreTests();
    },
    loadMoreTests() {
      this.testsLoading = true;
      if (this.isOnRouteListWhiteTests) {
        this.fetchConcoursBlancs({ page: this.page, subjectId: this.subjectId }).then(() => {
          this.testsLoading = false;
        });
      } else {
        this.fetchTests({ page: this.page, subjectId: this.subjectId }).then(() => {
          this.testsLoading = false;
        });
      }
    },
  },
  computed: {
    ...mapState(['tests', 'testsSubjects', 'concoursBlancs']),
    ...mapFields(['filters.tests.subjectId']),
    pageLength() {
      if (this.isOnRouteListWhiteTests) {
        return this.concoursBlancs.pages;
      }
      return this.tests.pages;
    },
    isOnRouteListQcm() {
      return this.$route.name === 'Liste QCM';
    },
    isOnRouteListWhiteTests() {
      return this.$route.name === 'Liste Concours Blancs';
    },
    items() {
      let filteredTests;
      if (this.isOnRouteListWhiteTests) {
        filteredTests = this.concoursBlancs.tests;
      } else if (this.isOnRouteListQcm) {
        filteredTests = this.tests.tests.filter((test) => !test.past_paper);
      } else {
        filteredTests = this.tests.tests.filter((test) => test.past_paper);
      }

      return filteredTests.map((test) => {
        let score;
        let bestScore;
        let worstScore;
        let titleIcon;
        let titleIconColor;

        if (!isNil(test.score)) {
          score = `${test.score.toFixed(2)}/${test.number_of_questions}`;
          bestScore = !isNil(test.best_score) && `${test.best_score.toFixed(2)}/${test.number_of_questions}`;
          worstScore = !isNil(test.worst_score) && `${test.worst_score.toFixed(2)}/${test.number_of_questions}`;
          if (test.score >= test.number_of_questions / 2) {
            titleIcon = 'mdi-check';
            titleIconColor = 'success';
          } else {
            titleIcon = 'mdi-close';
            titleIconColor = 'error';
          }
        } else {
          score = 'En attente';
          titleIcon = 'mdi-help';
          titleIconColor = 'warning';
        }
        return {
          title: test.name,
          titleIcon,
          titleIconColor,
          key: test.id,
          icon: 'mdi-format-list-checks',
          imageUrl: test.image_url,
          subtitles: [{
            name: 'Description',
            description: test.description,
          }, {
            name: 'Dernier',
            description: score,
          }, {
            name: 'Meilleur',
            description: bestScore,
          }, {
            name: 'Pire',
            description: worstScore,
          }, {
            name: 'Nombre de tentatives',
            description: test.number_of_student_tests,
          }],
          onClick: () => {
            if (test.white_test === true) {
              this.$router.push(`/concours_blancs/${test.id}`);
            } else if (test.past_paper) {
              this.$router.push(`/annales/${test.id}`);
            } else {
              this.$router.push(`/qcm/${test.id}`);
            }
          },
        };
      });
    },
  },
};
</script>
